var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('h1',{staticClass:"heading"},[_vm._v("Настройки")]),_c('p',[_vm._v("Раздел в разработке")])])}
var staticRenderFns = []

export { render, staticRenderFns }